import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { LoadTopData } from '@/api/Announcement';
import util from '@/libs/util';
export default {
  name: 'PortalNotice',
  data: function data() {
    return {
      filePath: this.$store.getters.getVUE_APP_DOWN,
      companyNoticeList: [],
      vendorNoticeList: [],
      noticeDialogVisilble: false,
      currentNotice: {}
    };
  },
  created: function created() {
    this.noticeInit();
  },
  methods: {
    noticeInit: function noticeInit() {
      var _this = this;

      // 获取公司公告
      this.getNoticeList({
        TYPE_ID: 1
      }).then(function (res) {
        _this.companyNoticeList = res;
      }); // 获取供应商须知

      this.getNoticeList({
        TYPE_ID: 2
      }).then(function (res) {
        _this.vendorNoticeList = res;
      });
    },
    getNoticeList: function getNoticeList() {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                _context.next = 3;
                return LoadTopData({
                  TYPE_ID: params.TYPE_ID,
                  TOP_COUNT: 15,
                  ORGANIZE_ID: '10' // util.cookies.get('ORG_ID')

                });

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res.data.Items);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    openNoticeDialog: function openNoticeDialog(notice) {
      this.noticeDialogVisilble = true;
      this.currentNotice = notice;
    }
  }
};